
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1386 -667)"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","transform":"translate(1386 667)","fill":"#484c50"}}),_c('path',{attrs:{"data-name":"Remove","d":"M1395.5 676.5l5 5m0-5l-5 5","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    